import { AfterViewInit, Component, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ReportCallDirections } from '@ndt/report-output/shared/models/call-direction-report-parameter';
import { Subject } from 'rxjs';
import { delay, takeUntil } from 'rxjs/operators';
import { ReportParameterComponent } from '../../report-parameter-list/report-parameter-component';
import { ReportParameterConfig } from '../../report-parameter-list/report-parameter.config';

@Component({
    providers: [{ multi: true, provide: NG_VALUE_ACCESSOR, useExisting: CallDirectionsReportParameterComponent }],
    selector: 'ndt-call-directions-report-parameter',
    templateUrl: './call-directions-report-parameter.component.html',
    standalone: false
})
export class CallDirectionsReportParameterComponent implements OnDestroy, AfterViewInit, ReportParameterComponent {
   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   config: ReportParameterConfig;

   callDirections = Object.values(ReportCallDirections);

   constructor() {
      this.form = new UntypedFormGroup({
         value: new UntypedFormControl(ReportCallDirections.Both),
      });
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   ngAfterViewInit(): void {
      this.form.controls.isAskParameter?.valueChanges.pipe(delay(0), takeUntil(this.destroyed$)).subscribe(() => {
         this.form.controls.callDirections?.updateValueAndValidity();
      });
   }

   callDirectionDisplayWith(option: ReportCallDirections): string {
      return `${option ?? ''}`;
   }
}
